 // Add smooth scrolling to all links with a hash
 $('a[href^="#"]').on('click', function (event) {
  // Prevent default anchor click behavior
  event.preventDefault();

  // Get the target element's ID from the href attribute
  var target = $(this).attr('href');

  // Animate scroll to the target element
  $('html, body').animate({
      scrollTop: $(target).offset().top
  }, 400); // Adjust the duration as needed
});